import { render, staticRenderFns } from "./legend_color_bar_tool.vue?vue&type=template&id=0fe5ecf4&scoped=true&"
import script from "./legend_color_bar_tool.vue?vue&type=script&lang=js&"
export * from "./legend_color_bar_tool.vue?vue&type=script&lang=js&"
import style0 from "./legend_color_bar_tool.vue?vue&type=style&index=0&id=0fe5ecf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe5ecf4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0fe5ecf4', component.options)
    } else {
      api.reload('0fe5ecf4', component.options)
    }
    module.hot.accept("./legend_color_bar_tool.vue?vue&type=template&id=0fe5ecf4&scoped=true&", function () {
      api.rerender('0fe5ecf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/emap/legend_color_bar_tool.vue"
export default component.exports